export default __webpack_public_path__ + "static/media/Person.b5924407.svg";